import React from 'react';
import { Form, Input, Row, Col, Segmented } from 'antd';
import { FilterOutlined, SkinOutlined, TagOutlined } from '@ant-design/icons';

import './styles.css';

export default function Filter(props) {
    return (
        <Form
            form={props.form}
            className={'mb-15'}
        >
            <Row gutter={[17]}>
                <Col span={24}>
                    <div className='content-filter inline-flex w-100'>
                        <Form.Item name="keyword" noStyle>
                            <Input
                                prefix={<FilterOutlined className='font-size-16' style={{ marginRight: 5 }} />}
                                placeholder="Buscar por palabra clave"
                                autoComplete="off"
                                bordered={false}
                                onKeyUp={(e) => {
                                    e.preventDefault();
                                    if (e.keyCode === 13)
                                        props.onLoad();
                                }}
                            />
                        </Form.Item>
                        <Form.Item name="productType" noStyle>
                            <Segmented
                                onChange={(value) => {
                                    props.setPagination({ ...props.pagination, page: 1 });
                                    props.setProductType(value)
                                }}
                                options={[
                                    {
                                        value: 1,
                                        label: 'Productos',
                                        icon: <SkinOutlined />,
                                    },
                                    {
                                        value: 2,
                                        label: 'Ofertas',
                                        icon: <TagOutlined />,
                                    }
                                ]}
                            />
                        </Form.Item>
                    </div>
                </Col>
            </Row>
        </Form>
    );
}